/*
Utilidades para v-data-table con celdas fusionadas (varios campos en una misma columna).
Vuetify solo busca en header.value, por eso se arma un custom-filter con la lista explicita de campos.
*/

function getPathValue(item, path) {
  return path.split(".").reduce((acc, key) => (acc === null || acc === undefined ? undefined : acc[key]), item);
}

/*
Devuelve un :custom-filter para v-data-table.
fields: lista de rutas de campo ("receiver.name") o funciones (item) => valor.
Vuetify lo invoca (value, search, item) por cada header con value: se ignora value y se compara contra todos los campos.
Sin distinguir mayusculas, por substring, tolerante a null/undefined.
*/
function buildCustomFilter(fields) {
  return (value, search, item) => {
    if (search === null || search === undefined || search === "") return true;
    if (!item) return false;
    const term = search.toString().toLowerCase();
    return fields.some((field) => {
      const v = typeof field === "function" ? field(item) : getPathValue(item, field);
      if (v === null || v === undefined) return false;
      return v.toString().toLowerCase().indexOf(term) !== -1;
    });
  };
}

/*
Nombre del cliente del receptor, solo si difiere del nombre del receptor (sin contar mayusculas ni espacios de mas).
*/
function getReceiverClientName(receiver) {
  const client = receiver ? receiver.client : null;
  if (!client || !client.name) return null;
  const normalize = (name) => (name || "").toString().trim().replace(/\s+/g, " ").toLowerCase();
  return normalize(client.name) !== normalize(receiver.name) ? client.name : null;
}

export const tableUtils = {
  buildCustomFilter,
  getReceiverClientName,
};
